import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import LoadingScreen from '@/shared/components/feedback/LoadingScreen'; // Assuming you have this

/**
 * PublicRouteOnly Component
 * 
 * Redirects to a specified path (e.g., /dashboard) if the user is already authenticated.
 * Otherwise, renders the children (e.g., the Login page).
 */
const PublicRouteOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isSignedIn, isLoaded } = useAuth(); // Directly use Clerk's hook

  if (!isLoaded) {
    // Show loading screen while Clerk is initializing to prevent premature redirects
    return <LoadingScreen />;
  }

  if (isSignedIn) {
    // If user is signed in, redirect them away from this public-only route
    return <Navigate to="/" replace />;
  }

  // If not signed in, render the children (e.g., Login page)
  return <>{children}</>;
};

export default PublicRouteOnly; 